.chartTitleRoot {
  display: flex;
  flex: 1;
}
